import { Component, computed, input } from '@angular/core';

type RGBA = `rgba(${number}, ${number}, ${number}, ${number})`;

@Component({
  selector: 'app-portal-panel',
  imports: [],
  templateUrl: './portal-panel.component.html',
  styleUrl: './portal-panel.component.css',
})
export class PortalPanelComponent {
  color = input<'blue' | 'green'>('blue');
  backgroundGradient = computed<{ stop1: RGBA; stop2: RGBA }>(() => {
    switch (this.color()) {
      case 'blue':
        return { stop1: 'rgba(53, 89, 160, 1)', stop2: 'rgba(101, 137, 208, 1)' };
      case 'green':
        return { stop1: 'rgba(103, 203, 9, 1)', stop2: 'rgba(39, 166, 7, 1)' };
    }
  });
  shadowInsetColor = computed<RGBA>(() => {
    switch (this.color()) {
      case 'blue':
        return 'rgba(38, 72, 139, 1)';
      case 'green':
        return 'rgba(46, 139, 10, 1)';
    }
  });
}
